<template>
  <div>
    <b-modal v-model="updatePlanModal"
             lazy
             @hide="handleModalHide"
             title="Update Subscription"
             @ok="handleUpdateSubscription">
      <p class="mb-2">You can quickly update your subscription package here.</p>
      <b-form-select
        class="large-bootstrap-select"
        v-model="selectedPriceId"
        :options="priceOptions"/>
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="d-flex justify-content-between w-100">
          <b-button variant="outline" class="btn-rounded" @click="cancel()">
            Cancel
          </b-button>

          <b-button variant="primary"
                    class="btn-rounded"
                    @click="handleOkClick(ok)"
                    :disabled="okActionType === 'disabled' || loading || finishedReactivating">

            <template v-if="loading || finishedReactivating">
              Please wait...
            </template>

            <template v-else-if="okActionType === 'disabled' || okActionType === 'update'">
              Update
            </template>

            <template v-else-if="okActionType === 'reactivate'">
              Reactivate
            </template>

            <template v-else-if="okActionType === 'reactivateConfirm'">
              Confirm reactivation
            </template>

          </b-button>
        </div>

      </template>
    </b-modal>
    <slot :handleButtonClick="activateModal"/>
  </div>
</template>

<script>
import {PlansApi} from "../../Api/PlansApi.js";
import {SubscriptionsApi} from "../../Api/SubscriptionsApi.js";
import GeneralMixins from "../../../mixins/GeneralMixins.js";

export default {
  mixins: [GeneralMixins],

  data() {
    return {
      updatePlanModal: false,
      selectedPriceId: null,
      currentPriceId: null,
      username: null,
      plans: [],
      subscription: null,
      reactivateConfirm: false,
      loading: false,
      finishedReactivating: false
    }
  },

  async mounted() {
    try {
      this.plans = await PlansApi.getPlans()
      this.subscription = await SubscriptionsApi.getSubscription()
      if (this.subscription) {
        this.selectedPriceId = this.subscription.stripe_price_id
        this.currentPriceId = this.subscription.stripe_price_id
      }
    } catch (e) {
      console.error(e)
    }

  },

  methods: {
    activateModal() {
      this.updatePlanModal = true
    },

    productPriceUrl(priceID) {
      return `/customers/subscriptions/new?price_id=${priceID}`
    },

    async handleUpdateSubscription() {
      if (this.selectedPriceId === this.currentPriceId && this.subscription?.canceled) {
        try {
          this.loading = true
          await SubscriptionsApi.reactivateSubscription(this.subscription.id)
          this.finishedReactivating = true
          window.location.reload()
        } catch (e) {
          this.showErrorToast("There was an error reactivating your subscription. Please try again later.")
        } finally {
          this.loading = false
        }
      } else {
        window.location.href = this.productPriceUrl(this.selectedPriceId)
      }
    },

    handleOkClick(modalOk) {
      if (this.okActionType === 'reactivate') {
        this.reactivateConfirm = true
      } else {
        this.handleUpdateSubscription()
      }
    },

    handleModalHide() {
      this.selectedPriceId = this.currentPriceId
      this.reactivateConfirm = false
    }
  },

  computed: {

    okActionType() {
      if (this.currentPriceId === this.selectedPriceId) {
        if (this.subscription?.canceled) {
          if (this.reactivateConfirm) {
            return 'reactivateConfirm'
          } else {
            return 'reactivate'
          }
        } else {
          return 'disabled'
        }
      } else {
        return 'update'
      }
    },

    currentPrices() {
      if (this.currentPlan) {
        const identifier = this.currentPlan.identifier
        return this.plans.filter(p => p.identifier === identifier).map(p => p.prices).flatten()
      } else if (this.subscription) {
        // the current plan is not available anymore. show prices from the same tier if possible
        return this.plans.filter(p => p.identifier === this.subscription.identifier).map(p => p.prices).flatten()
      } else {
        return []
      }
    },

    currentPlan() {
      return this.plans.find(p => p.prices.find(pr => pr.id === this.currentPriceId))
    },

    priceOptions() {
      return this.currentPrices.map(price => {
        return {
          value: price.id,
          text: `${price.name} - Renews each ${price.interval}`
        }
      })
    },
  }
}
</script>